(function() {
  class FsContactCardService {
    constructor() {
      this.CACHE = FS.cache.instance({storeName: 'contact_card', encrypted: true});
      this.cacheService = new FS.cache.service(this.CACHE, true, true)
    }

    getContactDataByCpId(id) {
      return this.cacheService.conditionalGet(`/service/tree/tree-data/user/${id}/contact-info`, `${id}_contact_info`, {preSaveCallback: this.preSaveCallback})
    }

    /**
     * Use contributors cp id to get the contributors cis id.
     * @param {string} cpUserId contributors cp id
     * @returns {Promise} Resolves with cis id or throws an error
     */
    getContributorCisId(cpUserId) {
      return FS.fetch(`/service/tree/ftuser/contacts/?contributorId=${cpUserId}`)
        .then(contributor => {
          return contributor.id
        })
        .catch(e => {
          console.error(e)
          throw(e)
        })
    }

    preSaveCallback(data) {
      var newData = {
        contactName: data.contactName,
        cpUserId: data.cpUserId,
        email: data.emailAddress,
        fullName: data.fullName,
        id: data.cisUserId,
        mailingAddress: data.mailingAddress,
        phoneNumber: data.phoneNumber,
        version: data.version
      }
      return newData;
    }
  }
  if(!window.__services__) window.__services__ = {};
  window.__services__.FsContactCardService = new FsContactCardService();
})();
